<!-- PAGINATION symbol to load on screen - START -->
<div #loading class="spinner-class" *ngIf="loaderActivated">
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</div>
<!-- PAGINATION symbol to load on screen - END -->

<div class="loggedin-feedback-container" *ngIf="!loaderActivated">
  <div class="love-to-hear-txt">
    {{ "help.guestfeedback" | cxTranslate }} 
  </div>
  <hr />
  <div class="feedback-detail-container" [formGroup]="loginFeedbackForm">
    <div class="row">
      <div class="col-lg-6">
        <div class="sub-heading-txt">{{ "help.firstname" | cxTranslate }} </div>
        <div class="sub-content-txt">{{ firstNameFetched }}</div>
      </div>
      <div class="col-lg-6">
        <div class="sub-heading-txt">{{ "help.lastname" | cxTranslate }} </div>
        <div class="sub-content-txt">{{ lastNameFetched }}</div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="row">
      <div class="col-lg-6">
        <div class="sub-heading-txt">{{ "help.singlesign" | cxTranslate }}</div>
        <div class="sub-content-txt">{{ uidFetched }}</div>
      </div>
      <div class="col-lg-6">
        <div class="sub-heading-txt">{{ "help.email" | cxTranslate }}</div>
        <div class="sub-content-txt email">{{emailAddressFetched}}</div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-sub-heading-txt">
          <span class="star"></span> {{ "help.reasonfeedback" | cxTranslate }}
        </div>
        <ng-select
          class="subject-dropdown"
          formControlName="subjectChosen"
          [ngClass]="
            isSubmitted &&
            loginFeedbackForm?.get('subjectChosen')?.errors?.required
              ? 'error-select'
              : ''
          "
          [searchable]="false"
          [clearable]="false"
          placeholder='{{ "help.selectPlaceholder" | cxTranslate }}'
        >
          <ng-option
            class="subject-dropdown-option"
            [value]="subject.code"
            *ngFor="let subject of subjectDropdownContents"
          >
            {{ subject.name }}
          </ng-option>
        </ng-select>
        <span
          class="error"
          *ngIf="
            isSubmitted &&
            loginFeedbackForm?.get('subjectChosen')?.errors?.required
          "
          >{{ "help.reasonfeedbackenter" | cxTranslate }}</span
        >
      </div>
    </div>
    <div class="divider"></div>
    <div class="row">
      <div class="col-lg-12">
        <div class="form-sub-heading-txt">
          <span class="star"></span> {{ "help.message" | cxTranslate }}
        </div>
        <div>
          <textarea
            class="subject-textarea-content"
            formControlName="subjectMessage"
            [maxlength]="maxSubjectMessageLength"
            (keyup)="checkLength($event)"
            [ngClass]="
              isSubmitted &&
              loginFeedbackForm?.get('subjectMessage')?.errors?.required
                ? 'error-select'
                : ''
            "
          ></textarea>
          <span
            class="error"
            *ngIf="
              isSubmitted &&
              loginFeedbackForm?.get('subjectMessage')?.errors?.required
            "
            >{{ "help.entermessage" | cxTranslate }}</span
          >
          <span class="characters-left"
            >{{ "help.characterleft" | cxTranslate }}
            {{ this.maxSubjectMessageLength - this.content.length }}</span
          >
        </div>
      </div>
    </div>
    <div class="divider"></div>

    <div class="mt-question">
      <vs-feedback-attachments
        (updateFiles)="updateFile($event)"
        (removeFile)="removedFile($event)"
      ></vs-feedback-attachments>
    </div>
    <div class="divider"></div>
    <div class="btn-area">
      <button class="vs-primary-btn" (click)="submitFeedback()">{{ "help.submitBtn" | cxTranslate }}</button>
    </div>
    <div class="divider"></div>
  </div>
</div>
